module.exports = __webpack_public_path__ + "static/media/Team 23 Environ LOGO - Zac Zhuo.e7696faf.png";